import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {ExchangeRateModel} from '@/libs/Api';
import {ExchangeRatesDataService} from '@/libs/exchange-rates/exchange-rates-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const exchangeRatesStore = registerCrudStore<ExchangeRateModel, ExchangeRateModel>(StoreName.ExchangeRate, new ExchangeRatesDataService());
